<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="pre"><a id="page_vii"></a><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc1a" id="fm-001"><a href="#/xhtml/frontmatter001#fm001">Who God Says You Are—and Should Be</a></p>
<p class="Toc1a" id="fm-002"><span href="#/xhtml/frontmatter002#fm002" title="Link target outside of Sample">Faith Transforms Identity</span></p>
<p class="Toc" id="ch-001"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample"><span class="small">FACTOR 1</span><span class="space">You Are Your Body</span></span></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample"><span class="small">FACTOR 2</span><span class="space">You Are Your History</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample"><span class="small">FACTOR 3</span><span class="space">You Are Your Relations</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample"><span class="small">FACTOR 4</span><span class="space">You Are Your Mind</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample"><span class="small">FACTOR 5</span><span class="space">You Are Your Commitments</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample"><span class="small">FACTOR 6</span><span class="space">You Are Your Actions</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample"><span class="small">FACTOR 7</span><span class="space">You Are Your Boundaries</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample"><span class="small">FACTOR 8</span><span class="space">You Are an Ongoing Process of Change</span></span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample"><span class="small">FACTOR 9</span><span class="space">You Are Your Future</span></span></p>
<p class="Toc1a" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">A Final Appeal for Identity—That You Become a Person</span></p>
<p class="Toc1" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Select Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Names and Subjects</span></p>
<p class="Toc1" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Index of Scripture References</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e9d3306a